import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

const Video = ({
  _css,
  autoPause,
  autoPlay,
  loop,
  muted,
  playing,
  playsInline,
  poster,
  src
}) => {
  const { scrollTop, windowHeight } = 0;
  const videoRef = useRef();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (videoRef?.current && !loaded) {
      setLoaded(true);

      videoRef.current.onpause = () => {
        if (videoRef?.current) {
          videoRef.current.playing = false;
        }
      };

      videoRef.current.onplaying = () => {
        if (videoRef?.current) {
          videoRef.current.playing = true;
        }
      };
    }
  }, [videoRef.current]);

  useEffect(() => {
    if (!autoPause || !loaded) {
      return;
    }

    const { height, top } = videoRef.current.getBoundingClientRect();
    const video = videoRef.current;

    if (top > -height && top < windowHeight) {
      if (!video.playing) {
        video.play();
      }
    } else if (video.playing) {
      video.pause();
    }
  }, [scrollTop]);

  useEffect(() => {
    if (!loaded) {
      return;
    }

    const video = videoRef.current;

    if (playing) {
      if (!video.playing) {
        video.play();
      }
    } else if (video.playing) {
      video.pause();
    }
  }, [loaded, playing, videoRef.current]);

  return (
    <video
      css={_css}
      ref={videoRef}
      autoPlay={autoPlay}
      muted={muted}
      loop={loop}
      playsInline={playsInline}
      poster={poster}
    >
      <source src={src} />
    </video>
  );
};

Video.defaultProps = {
  _css: [],
  autoPause: true,
  autoPlay: false,
  loop: true,
  muted: true,
  playing: true,
  playsInline: true,
  poster: null,
  src: ``
};

Video.propTypes = {
  _css: PropTypes.arrayOf(PropTypes.shape({})),
  autoPause: PropTypes.bool,
  autoPlay: PropTypes.bool,
  loop: PropTypes.bool,
  muted: PropTypes.bool,
  playing: PropTypes.bool,
  playsInline: PropTypes.bool,
  poster: PropTypes.string,
  src: PropTypes.string
};

export default Video;
